import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import emptyLayout from '@/layouts/emptyLayout.vue'
import mainLayout from '@/layouts/mainLayout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const layout = computed(() => {
  const mainLayoutNames = ['main-layout', 'MainLayout', 'mainLayout', 'main_layout']
  const layout = route.meta?.layout ?? ''

  return mainLayoutNames.includes(layout) ? mainLayout : emptyLayout
})

return { __sfc: true,route, layout }
}

})